import {Injectable, NgZone} from '@angular/core';
import {Observable, Observer} from 'rxjs';

import {ExgMapKmlLayerComponent} from '../../exg-map-kml-layer/exg-map-kml-layer.component';
import {ExgMapGoogleAPIWrapper} from '../exg-map-google-api-wrapper.service';

/**
 * Manages all KML Layers for a Google Map instance.
 */
@Injectable()
export class ExgMapKmlLayerManagerService {
  private _layers: Map<ExgMapKmlLayerComponent, Promise<google.maps.KmlLayer>> =
    new Map<ExgMapKmlLayerComponent, Promise<google.maps.KmlLayer>>();

  constructor(private _wrapper: ExgMapGoogleAPIWrapper, private _zone: NgZone) {
  }

  /**
   * Adds a new KML Layer to the map.
   */
  addKmlLayer(layer: ExgMapKmlLayerComponent): void {
    const newLayer = this._wrapper.getNativeMap().then(m => {
      return new google.maps.KmlLayer({
        clickable: layer.clickable,
        map: m,
        preserveViewport: layer.preserveViewport,
        screenOverlays: layer.screenOverlays,
        suppressInfoWindows: layer.suppressInfoWindows,
        url: layer.url as any,
        zIndex: layer.zIndex as any,
      });
    });
    this._layers.set(layer, newLayer);
  }

  setOptions(layer: ExgMapKmlLayerComponent, options: google.maps.KmlLayerOptions): void {
    // @ts-ignore
    this._layers.get(layer).then(l => l.setOptions(options));
  }

  deleteKmlLayer(layer: ExgMapKmlLayerComponent): void {
    // @ts-ignore
    this._layers.get(layer).then(l => {
      l.setMap(null);
      this._layers.delete(layer);
    });
  }

  /**
   * Creates a Google Maps event listener for the given KmlLayer as an Observable
   */
  createEventObservable<T>(eventName: string, layer: ExgMapKmlLayerComponent): Observable<T> {
    return new Observable((observer: Observer<T>) => {
      // @ts-ignore
      this._layers.get(layer).then((m: google.maps.KmlLayer) => {
        m.addListener(eventName, (e: T) => this._zone.run(() => observer.next(e)));
      });
    });
  }
}
